import { CancelTokenSource } from 'axios';
import apiClient, { makeQueryString, WrappingApiClient } from 'libs/api/apiClient';
import { TInterviewReview } from 'modules/community';
import { TInterviewReviewPostFormat } from 'modules/community';
import { TListRequestParams } from 'modules/types';

type TGetInterviewReviewParams = {
  q?: string;
  current?: number;
  pageSize?: number;
  is_pass_review?: string;
  is_consulting_firm?: string;
  employment_types?: string;
  interview_years?: number;
};

//List 데이터 get
//params 구조분해 할당
export const getInterviewReviewList = ({ params }: { params: TGetInterviewReviewParams }) => {
  return apiClient.get<Array<TInterviewReview>>(`/community/interview_reviews`, { params });
};

//인터뷰 후기 작성 Post
export const createInterviewReview = (params: TInterviewReviewPostFormat) => {
  return WrappingApiClient(apiClient.post('/community/interview_review', params));
};

//회사 이름
export const communityAutoCompleteCompanyName = (
  { params }: TListRequestParams,
  cancel?: CancelTokenSource,
) => {
  return apiClient.get('/community/autocomplete/company', {
    params: params,
    cancelToken: cancel?.token,
  });
};

//인터뷰 리뷰, 최종합격 후기 페이지 조회수
export const communityHitConut = (params: { board: string }) => {
  return apiClient.get(`/community/hit_count?${makeQueryString(params)}`);
};

export const communityAutoCompleteUniversityName = (
  { params }: TListRequestParams,
  cancel?: CancelTokenSource,
) => {
  return apiClient.get('/community/autocomplete/university', {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const communityAutoCompleteMajorName = (
  { params }: TListRequestParams,
  cancel?: CancelTokenSource,
) => {
  return apiClient.get('/community/autocomplete/major', {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const communityExcelHitCount = (params: { board: string }) => {
  return apiClient.get(`/community/hit_count/excel_video?${makeQueryString(params)}`);
};
